<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book1/xhtml/cover">AFTERLIFE</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter01">1</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter02">2</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter03">3</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter04">4</a></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter05" title="Link target outside of Sample">5</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter06" title="Link target outside of Sample">6</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter07" title="Link target outside of Sample">7</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter08" title="Link target outside of Sample">8</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter09" title="Link target outside of Sample">9</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter10" title="Link target outside of Sample">10</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter11" title="Link target outside of Sample">11</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter12" title="Link target outside of Sample">12</span></p>
<p class="toc2"><span href="#/Book2/xhtml/cover" title="Link target outside of Sample">HALFWAY HOME</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter01" title="Link target outside of Sample">One</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter02" title="Link target outside of Sample">Two</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter03" title="Link target outside of Sample">Three</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter04" title="Link target outside of Sample">Four</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter05" title="Link target outside of Sample">Five</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter06" title="Link target outside of Sample">Six</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter07" title="Link target outside of Sample">Seven</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter08" title="Link target outside of Sample">Eight</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter09" title="Link target outside of Sample">Nine</span></p>
<p class="toc1"><span href="#/Book2/xhtml/chapter10" title="Link target outside of Sample">Ten</span></p>
<p class="toc2"><a href="#/Book3/1cover#cover">LOVE ALONE</a></p>
<p class="toc2"><a href="#/Book3/8chap2#chap2">I</a></p>
<p class="toc1"><a href="#/Book3/9chap3#chap3">Here</a></p>
<p class="toc1"><a href="#/Book3/10chap4#chap4">No Goodbyes</a></p>
<p class="toc1"><a href="#/Book3/11chap5#chap5">Your Sightless Days</a></p>
<p class="toc1"><a href="#/Book3/12chap6#chap6">Gardenias</a></p>
<p class="toc1"><a href="#/Book3/13chap7#chap7">The Worrying</a></p>
<p class="toc1"><a href="#/Book3/14chap8#chap8">Readiness</a></p>
<p class="toc1"><a href="#/Book3/15chap9#chap9">Half Life</a></p>
<p class="toc1"><a href="#/Book3/16chap10#chap10">Black Xmas</a></p>
<p class="toc1"><a href="#/Book3/17chap11#chap11">The Very Same</a></p>
<p class="toc1"><a href="#/Book3/18chap12#chap12">New Year's at Lawrence's Grave</a></p>
<p class="toc2"><a href="#/Book3/19chap13#chap13">II</a></p>
<p class="toc1"><a href="#/Book3/20chap14#chap14">Three Rings</a></p>
<p class="toc1"><a href="#/Book3/21chap15#chap15">Current Status 1/22/87</a></p>
<p class="toc1"><a href="#/Book3/22chap16#chap16">The Losing Side</a></p>
<p class="toc1"><a href="#/Book3/23chap17#chap17">Manifesto</a></p>
<p class="toc1"><a href="#/Book3/24chap18#chap18">The House on Kings Road</a></p>
<p class="toc2"><a href="#/Book3/25chap19#chap19">III</a></p>
<p class="toc1"><a href="#/Book3/26chap20#chap20">Last Day at Molera Beach</a></p>
<p class="toc1"><a href="#/Book3/27chap21#chap21">Dreaming of You</a></p>
<p class="toc1"><a href="#/Book3/28chap22#chap22">Brother of the Mount of Olives</a></p>
<p class="toc2"><a href="#/Book4/1cover#cover">WEST OF YESTERDAY, EAST OF SUMMER</a></p>
<p class="toc2"><a href="#/Book4/6chap2#chap2">New Poems (1987-1993)</a></p>
<p class="toc1"><a href="#/Book4/8chap3#chap3">Committing to Memory</a></p>
<p class="toc1"><a href="#/Book4/9chap4#chap4">The Supreme Pork</a></p>
<p class="toc1"><a href="#/Book4/10chap5#chap5">40</a></p>
<p class="toc1"><a href="#/Book4/11chap6#chap6">Nureyev Doesn't Have AIDS</a></p>
<p class="toc1"><a href="#/Book4/12chap7#chap7">Dr. Burnout</a></p>
<p class="toc1"><a href="#/Book4/13chap8#chap8">The Bee-Eater</a></p>
<p class="toc1"><a href="#/Book4/14chap9#chap9">Buckley</a></p>
<p class="toc1"><a href="#/Book4/15chap10#chap10">Ed Dying</a></p>
<p class="toc1"><a href="#/Book4/16chap11#chap11">To GB from Tuscany</a></p>
<p class="toc1"><a href="#/Book4/17chap12#chap12">Waiting to Die</a></p>
<p class="toc1"><a href="#/Book4/18chap13#chap13">Stephen at the FDA</a></p>
<p class="toc2"><a href="#/Book4/19chap14#chap14">Love Alone: 18 Elegies for Rog (1988)</a></p>
<p class="toc1"><a href="#/Book4/20chap15#chap15">Preface</a></p>
<p class="toc1"><a href="#/Book4/21chap16#chap16">Here</a></p>
<p class="toc1"><a href="#/Book4/22chap17#chap17">Gardenias</a></p>
<p class="toc1"><a href="#/Book4/23chap18#chap18">The Worrying</a></p>
<p class="toc1"><a href="#/Book4/24chap19#chap19">New Year's at Lawrence's Grave</a></p>
<p class="toc1"><a href="#/Book4/25chap20#chap20">Manifesto</a></p>
<p class="toc1"><a href="#/Book4/26chap21#chap21">The House on Kings Road</a></p>
<p class="toc1"><a href="#/Book4/27chap22#chap22">Brother of the Mount of Olives</a></p>
<p class="toc2"><a href="#/Book4/28chap23#chap23">No Witnesses (1981)</a></p>
<p class="toc1"><a href="#/Book4/29chap24#chap24">My Shirts</a></p>
<p class="toc1"><a href="#/Book4/30chap25#chap25">Bones and Jewels</a></p>
<p class="toc1"><a href="#/Book4/31chap26#chap26">The Wedding Letter</a></p>
<p class="toc1"><a href="#/Book4/32chap27#chap27">Musical Comedy</a></p>
<p class="toc2"><a href="#/Book4/33chap28#chap28">The Carpenter at the Asylum (1975)</a></p>
<p class="toc1"><a href="#/Book4/34chap29#chap29">October in Massachusetts</a></p>
<p class="toc1"><a href="#/Book4/35chap30#chap30">Paris Days</a></p>
<p class="toc1"><a href="#/Book4/36chap31#chap31">Janis Joplin's Death</a></p>
<p class="toc1"><a href="#/Book4/37chap32#chap32">Contexts</a></p>
<p class="toc2"><a href="#/Book4/38chap33#chap33">Acknowledgments</a></p>
<p class="toc2"><span href="#/Comon/bio_images" title="Link target outside of Sample">A Biography of Paul Monette</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?4c0733da